import client from './client'

export interface DeploymentConfigTexts {
  intro: string
  outro: string
  fallback_questions: string[]
}

export interface DeploymentConfig {
  company_name: string
  job_title: string
  texts: {
    de: DeploymentConfigTexts
    en: DeploymentConfigTexts
  }
}

export async function fetchDeploymentConfig(): Promise<DeploymentConfig> {
  const { data } = await client.get<DeploymentConfig>('/deployment/config')
  return data
}